module.exports = __webpack_public_path__ + "static/onTheIssues_Education-077945d06f0ee5dc4d8759fe5944695f.jpg";